import moment from "moment"
import { formatPhoneNumberIntl } from 'react-phone-number-input'
import momenttz from "moment-timezone";

const timezones = momenttz.tz.names().map(name => ({
  value: name,
  label: `(GMT${momenttz.tz(name).format("Z")}) ${name}`
}));

export const getTimezones = () => {
  return timezones;
};

export function generateRandomString(length = 20) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let result = ''

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    result += characters[randomIndex]
  }

  return result
}

export const formatDateForOffer = (date) => {
  return moment(date[0]).utcOffset(0).format("YYYY-MM-DDTHH:mm:ss\\Z")
}

export const formatDate = (date) => {
  return moment(date[0]).utcOffset(0).format("YYYY-MM-DDTHH:mm:ss\\Z")
}

export const formatDateForDisplay = (date, timeFormat) => {
  const dateFormatCommon = localStorage.getItem("dateFormat") || "DD MMM YYYY";
  const dateFormat = timeFormat ? `${dateFormatCommon}, ${timeFormat}` : dateFormatCommon;
  return moment(date).format(dateFormat)
}

export const formatDateForPayload = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getCurrentWeekRange = () => {
  const today = new Date();

  // 0 = Sunday, 1 = Monday, ... 6 = Saturday
  const day = today.getDay();

  // Calculate Monday
  const monday = new Date(today);
  monday.setDate(today.getDate() - ((day + 6) % 7));

  // Calculate Sunday
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  // Format YYYY-MM-DD
  const format = (d) => d.toISOString().split("T")[0];

  return {
    from: format(monday),
    to: format(sunday),
  };
};

export function getValidityInDays(validFrom, validTo) {
  const start = new Date(validFrom);
  const end = new Date(validTo);
  return Math.ceil((end - start) / (1000 * 60 * 60 * 24));
}

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  return formatPhoneNumberIntl(phoneNumber);
};

export const formatCellValue = (value, format) => {
  if (value === undefined || value === null || value?.toString().trim() === "") {
    return "-";
  }
  if (typeof value === 'object') return value?.value ?? '-';
  return typeof format === "function" ? format(value) : value;
};

export const buildPermissionsMap = (modules) => {
   const permissionsMap = new Map();

  modules.forEach((module) => {
    permissionsMap.set(
      module?.module?.toLowerCase(),
      module?.submodules?.length > 0
    );

    module?.submodules?.forEach((submodule) => {
      permissionsMap.set(
        `${module?.module?.toLowerCase()}-${submodule?.submodule?.toLowerCase()}`,
        new Set(submodule.permissions)
      );
    });
  });

  return permissionsMap;

}

export const hasPermission = (permissionsMapObject,module, submodule, permission) =>{
  if (!module || !permissionsMapObject) return false;

  if (!submodule) return permissionsMapObject.has(module.toLowerCase());

  const key = `${module.toLowerCase()}-${submodule.toLowerCase()}`;

  if(!permission) return permissionsMapObject.get(key);

  const permissionSet = permissionsMapObject.get(key);

  return permissionSet?.has(permission) ?? false;

}





